import { cloneDeep } from 'lodash';
import { get, getArrayBuffer } from '@/helpers/httpHandler';
import { SubscriptionsService } from '@/services/subscriptions.service';

export default {
  getItemsList({ commit }, { params } = {}) {
    return SubscriptionsService.getList({
      ...params.filters,
      ...params.paginationOptions
    }).then(response => {
      commit('setFilters', cloneDeep(params.filters));
      commit('setPaginationOptions', cloneDeep(params.paginationOptions));

      return response;
    });
  },

  getFilteredFirstNames(_, params) {
    return get(`/subscriptions/filters/first-name`, params);
  },

  getFilteredLastNames(_, params) {
    return get(`/subscriptions/filters/last-name`, params);
  },

  getAboServicesFilterList(_, params) {
    return get(`/subscriptions/filters/abo-services`, params);
  },

  retrieveSubscriptions: () => get('/subscriptions'),

  retrieveSubscription(_, subscriptionId) {
    return SubscriptionsService.getById(subscriptionId);
  },

  updateSubscription(_, { subscriptionId, subscription }) {
    return SubscriptionsService.update(subscriptionId, subscription);
  },

  getBillingPeriods: () => get('/subscriptions/billing-periods'),

  getSubscriptionsExport(_, params) {
    return getArrayBuffer(`/subscriptions/export`, params);
  }
};
